module.exports = __webpack_public_path__ + "static/media/GazindoLogo&Text.dc2ebc37.png";